import styled from "styled-components";

export const SkillsContainer = styled.section`
  margin-top: 5rem;
  padding: 2rem;
  display: grid;
  place-items: center;

  h2 {
    font-size: 3rem;
    color: #ffffff;
    text-align: center;
    margin-bottom: 3rem;
  }

  @media (max-width: 740px) {
    padding: 1rem;

    h2 {
      font-size: 2.2rem;
    }
  }
`;

export const ServicesGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  width: 100%;
  max-width: 1200px;
  padding: 0 1rem;
  justify-content: center;

  @media (max-width: 768px) {
    gap: 1.5rem;
  }
`;

export const ServiceCard = styled.div`
  background-color: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 1rem;
  padding: 2rem;
  width: 100%;
  max-width: 400px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(0, 224, 255, 0.25);
    border-color: #00e0ff;
  }

  @media (max-width: 740px) {
    padding: 1.5rem;
  }
`;

export const ServiceIcon = styled.div`
  font-size: 3.2rem;
  margin-bottom: 1rem;
  line-height: 1;

  @media (max-width: 740px) {
    font-size: 2.7rem;
  }
`;

export const ServiceTitle = styled.h3`
  font-size: 1.7rem;
  font-weight: 600;
  color: var(--green);
  margin-bottom: 1rem;
  line-height: 1.3;

  @media (max-width: 740px) {
    font-size: 1.5rem;
  }
`;

export const ServiceDescription = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;

  @media (max-width: 740px) {
    font-size: 1.15rem;
  }
`;
